import { DELETE_API, GET_API, POST_API, PUT_API } from "./APIS";

export const ManageApis = async (method, path, params, headers) => {
  if (method === "post") {
    let results = await POST_API(params, path, headers);
    if (results.status_code) {
      return results;
    } else {
      return results.message;
    }
  } else if (method === "get") {
    let results = await GET_API(path, headers, params);
    if (results.status_code) {
      return results;
    } else {
      return results.message;
    }
  } else if (method === "delete") {
    let results = await DELETE_API(path, headers, params);
    if (results.status_code) {
      return results;
    } else {
      return results.message;
    }
  } else if (method === "put") {
    let results = await PUT_API(params, path, headers);
    if (results.status_code) {
      return results;
    } else {
      return results.message;
    }
  }
};
